import PropTypes from 'prop-types'
import React from 'react'
import { usePage } from 'client/store'
import pageSelectors from 'client/store/page/pageSelectors'
import { wrapFontFamily } from '../../common/components/entities/Text/utils'
import { ActivePopup } from './components/popup/active-popup'
import PageUi from './ui/PageUi'
import { useTypography } from 'src/editor/shared/hooks/use-typography'

function CommonPage({ children }) {
  const { globalFontFamily, globalFontStyle, globalFontWeight } =
    useTypography()
  return (
    <PageUi
      fontFamily={wrapFontFamily(globalFontFamily)}
      fontWeight={globalFontWeight}
      fontStyle={globalFontStyle}
    >
      {children}
      <ActivePopup />
    </PageUi>
  )
}

CommonPage.propTypes = {
  children: PropTypes.node.isRequired,
}

export default CommonPage
